import * as React from 'react'
import { BACKEND_BASE } from '../../../constants'

type Props = {
  beamType: string
  dimensions?: boolean
  requestWidth?: number
  leftSlab?: string | null
  rightSlab?: string | null
  location?: string | null
  onClick?: () => void
}

class BeamProfileView extends React.Component<Props> {
  render() {
    const {
      beamType,
      dimensions,
      requestWidth,
      leftSlab,
      rightSlab,
      location
    } = this.props
    let params: string[] = []

    if (beamType === null) {
      return null
    }

    if (dimensions) {
      params.push('dimensions=1')
    }

    if (requestWidth) {
      params.push(`width=${requestWidth}`)
    }

    if (leftSlab) {
      params.push(`leftSlab=${leftSlab}`)
    }

    if (rightSlab) {
      params.push(`rightSlab=${rightSlab}`)
    }

    if (location) {
      params.push(`location=${location}`)
    }

    const url = `${BACKEND_BASE}profile/${beamType}?${params.join('&')}`

    return <img src={url} onClick={this.props.onClick} />
  }
}

export default BeamProfileView



// WEBPACK FOOTER //
// ./src/Components/Results/BeamProfile/index.tsx